import { useState } from "react";

import DstButton from "../../../../../components/DstButton/DstButton";
import MultiSelectLiveDropdown from "../../../../../components/MultiSelectLiveDropdown/MultiSelectLiveDropdown";
import Popup from "../../../../../components/Popup/Popup";
import translate from "../../../../../services/Translate";
import { addCohortsToAttendance } from "../ManageMeeting.function";
import { CohortsAttendancePopupProps } from "./CohortsAttendancePopup.d";

const CohortAttendancePopup = ({
  meetingId,
  language,
  openAddCohortsModal,
  setOpenAddCohortsModal,
  refreshMeeting,
}: CohortsAttendancePopupProps) => {
  const [cohortsToAdd, setCohortsToAdd] = useState<number[]>([]);
  const [isAdding, setIsAdding] = useState(false);

  return (
    <Popup
      show={openAddCohortsModal}
      onClose={() => setOpenAddCohortsModal(false)}
      modalTitle={translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.COHORTS.TITLE")}
    >
      <div className="d-flex flex-column">
        <div className="flex-grow-1">
          <MultiSelectLiveDropdown
            category={["cohorts"]}
            label={
              cohortsToAdd && cohortsToAdd.length > 0
                ? `${cohortsToAdd.length} ${translate(
                    language,
                    "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.COHORTS.SELECTED"
                  )}`
                : translate(language, "PAGES.MEETING.MANAGE_MEETING.ATTENDANCE.POPUP.COHORTS.PLACEHOLDER")
            }
            language={language}
            mockClass="rounded-0 rounded-end"
            toggleClass="min-w-100px m-regular"
            onConfirm={(selectedCohorts: any[]) => setCohortsToAdd(selectedCohorts.map((cohort) => cohort.value.id))}
            showFilterButton={false}
            clearItemsOnSend={false}
          />
        </div>
        <div className="d-flex justify-content-end mt-4">
          <DstButton
            btnWidth="100px"
            variant="primary"
            value={translate(language, "GLOBAL.ADD")}
            clickFunction={() => {
              setIsAdding(true);
              addCohortsToAttendance(
                meetingId,
                cohortsToAdd,
                language,
                () => {
                  setOpenAddCohortsModal(false);
                  refreshMeeting();
                  setCohortsToAdd([]);
                },
                () => {
                  setIsAdding(false);
                }
              );
            }}
            btnClass="me-2"
            loading={isAdding}
          />
        </div>
      </div>
    </Popup>
  );
};

export default CohortAttendancePopup;
